import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, Flex, styled } from '@withjoy/joykit';

// Named styled components
export const StyledRoot = styled(Box)``;
export const StyledContainer = styled(Box)``;
export const StyledContent = styled(Flex)``;

const containerStyles: StyleSystemProps = {
  flexWrap: 'wrap',
};

export const styles = {
  container: containerStyles,
};
